export interface IColumnFilterValue {
  operator: string;
  value: any;
}

export const stringFilterFn = (row: any, columnId: string, filterValue: IColumnFilterValue) => {
  const cell = String(row.getValue(columnId) ?? '').toLowerCase();
  const needle = String(filterValue?.value ?? '').toLowerCase();

  if (!needle) return true;

  return filterValue.operator === 'equals' ? cell === needle : cell.includes(needle);
};

export const numericFilterFn = (row: any, columnId: string, filterValue: IColumnFilterValue) => {
  if (filterValue?.value === '' || filterValue?.value === undefined || filterValue?.value === null) return true;

  const cell = Number(row.getValue(columnId));
  const target = Number(filterValue.value);

  switch (filterValue.operator) {
    case '>':
      return cell > target;
    case '<':
      return cell < target;
    case '<=':
      return cell <= target;
    case '>=':
      return cell >= target;
    case '=':
    default:
      return cell === target;
  }
};

export const dateFilterFn = (row: any, columnId: string, filterValue: IColumnFilterValue) => {
  if (!filterValue?.value) return true;

  const cell = new Date(row.getValue(columnId) as string).setHours(0, 0, 0, 0);
  const target = new Date(filterValue.value).setHours(0, 0, 0, 0);

  switch (filterValue.operator) {
    case 'after':
      return cell > target;
    case 'before':
      return cell < target;
    case 'onOrAfter':
      return cell >= target;
    case 'onOrBefore':
      return cell <= target;
    case 'is':
    default:
      return cell === target;
  }
};

export const booleanFilterFn = (row: any, columnId: string, filterValue: IColumnFilterValue) => {
  if (filterValue?.value === '' || filterValue?.value === undefined) return true;
  return Boolean(row.getValue(columnId)) === Boolean(filterValue.value);
};

export const operatorsByType: Record<string, { value: string; label: string }[]> = {
  string: [
    { value: 'contains', label: 'contains' },
    { value: 'equals', label: 'equals' },
  ],
  number: [
    { value: '=', label: '=' },
    { value: '>', label: '>' },
    { value: '<', label: '<' },
    { value: '>=', label: '>=' },
    { value: '<=', label: '<=' },
  ],
  date: [
    { value: 'is', label: 'is' },
    { value: 'after', label: 'is after' },
    { value: 'before', label: 'is before' },
    { value: 'onOrAfter', label: 'is on or after' },
    { value: 'onOrBefore', label: 'is on or before' },
  ],
  dateTime: [
    { value: 'is', label: 'is' },
    { value: 'after', label: 'is after' },
    { value: 'before', label: 'is before' },
    { value: 'onOrAfter', label: 'is on or after' },
    { value: 'onOrBefore', label: 'is on or before' },
  ],
  boolean: [{ value: 'is', label: 'is' }],
};

export const filterFnByType: Record<string, (row: any, columnId: string, filterValue: IColumnFilterValue) => boolean> = {
  string: stringFilterFn,
  number: numericFilterFn,
  date: dateFilterFn,
  dateTime: dateFilterFn,
  boolean: booleanFilterFn,
};
